import { useEffect } from "react";

const SITE = "https://flowtechsolutions.site";

const setMeta = (attr, key, content) => {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

export const Seo = ({ title, description, path = "/", jsonLd = [] }) => {
    const jsonKey = JSON.stringify(jsonLd);
    useEffect(() => {
        const url = `${SITE}${path}`;
        document.title = title;
        setMeta("name", "description", description);
        setMeta("property", "og:title", title);
        setMeta("property", "og:description", description);
        setMeta("property", "og:url", url);
        setMeta("name", "twitter:title", title);
        setMeta("name", "twitter:description", description);
        let link = document.head.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            document.head.appendChild(link);
        }
        link.setAttribute("href", url);
        const scripts = jsonLd.map((data, i) => {
            const s = document.createElement("script");
            s.type = "application/ld+json";
            s.setAttribute("data-seo-jsonld", String(i));
            s.text = JSON.stringify(data);
            document.head.appendChild(s);
            return s;
        });
        return () => scripts.forEach((s) => s.remove());
    }, [title, description, path, jsonKey]);
    return null;
};

export const ORGANIZATION_LD = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Flowtech",
    url: SITE,
    logo: `${SITE}/favicon.svg`,
    description:
        "Flowtech builds AI employees and business automation systems for service businesses — lead follow-up, appointment scheduling, customer communication, and CRM automation.",
    email: "admin@flowtechsolutions.site",
    areaServed: "United States",
    sameAs: ["https://www.facebook.com/flowtechsolutionsph"],
};

export const WEBSITE_LD = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Flowtech",
    url: SITE,
};

export const breadcrumbLd = (items) => ({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: it.name,
        item: `${SITE}${it.path}`,
    })),
});
